import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SprintfulRecordResponse } from 'src/app/shared/models/sprintful/sprintful.model';

@Injectable({
  providedIn: 'root',
})
export class AgendaSigningApiService {
  typeEnvironmentApim = environment.Apim;

  constructor(private readonly http: HttpClient) { }

  // Detalle de agendas Sprintful contra el orquestador de migración. El body
  // es el arreglo plano de ids, sin `criteria` ni envoltorio `data`.
  getSprintfulDetail(recordIds: string[]): Observable<SprintfulRecordResponse[]> {
    return this.http.post<SprintfulRecordResponse[]>(
      `${this.typeEnvironmentApim.migration_host}/` +
      `${this.typeEnvironmentApim.migration_paths.api}/` +
      `${this.typeEnvironmentApim.migration_paths.sprintful}/` +
      `${this.typeEnvironmentApim.migration_paths.sprintfulDetail}`,
      recordIds
    );
  }

  createReservation(payload: any): Observable<any> {
    return this.http.post(
      `${this.typeEnvironmentApim.migration_host}/` +
      `${this.typeEnvironmentApim.migration_paths.api}/` +
      `${this.typeEnvironmentApim.migration_paths.sprintful}/` +
      `${this.typeEnvironmentApim.migration_paths.sprintfulCreate}`,
      payload,
    );
  }

  cancelReservation(reservationId: string): Observable<any> {
    return this.http.post(
      `${this.typeEnvironmentApim.migration_host}/` +
      `${this.typeEnvironmentApim.migration_paths.api}/` +
      `${this.typeEnvironmentApim.migration_paths.sprintful}/` +
      `${this.typeEnvironmentApim.migration_paths.sprintfulCancel}`,
      { reservationId },
    );
  }

  rescheduleReservation(reservationId: string, newDate: string): Observable<any> {
    return this.http.post(
      `${this.typeEnvironmentApim.migration_host}/` +
      `${this.typeEnvironmentApim.migration_paths.api}/` +
      `${this.typeEnvironmentApim.migration_paths.sprintful}/` +
      `${this.typeEnvironmentApim.migration_paths.sprintfulReschedule}`,
      { reservationId, newDate },
    );
  }
}
